<template>
  <div class="file-render" flex>
    <div v-if="fileType === 'image'">
      <img class="image-file" :src="fileInfo.fileUrl">
    </div>
    <audio-play :playbackControl="playbackControl" :isLineFile="isLineFile" @play="$emit('play')" :mobile="mobile" :style="{width: showHandler ? '256px' : '100%'}" v-if="fileType === 'audio'" :url="fileInfo.fileUrl"></audio-play>

    <!-- <div > -->
      <!--        <video class="video-file" controls="controls" :src="fileInfo.fileUrl"></video>-->
      <video-play :playbackControl="playbackControl" :isLineFile="isLineFile" @play="$emit('play')" :mobile="mobile" v-if="fileType === 'video'" :url="fileInfo.fileUrl"></video-play>
    <!-- </div> -->

    <div class="file-info" :class="{videoHandler: fileType === 'video'}" style="margin-left: 28px" v-if="showHandler">
      <template v-if="fileType !== 'audio'">
      <el-tooltip v-if="fileInfo.fileName" popper-class="atooltip" class="item" effect="dark" :content="`文件名称：${fileInfo.fileName}`" placement="top-start">
        <div class="fileName text-overflow">文件名称：{{ fileInfo.fileName }}</div>
      </el-tooltip>
        <div class="fileInfo" v-if="fileInfo.duration">视频时长：{{ fileInfo.duration }}</div>
        <div class="fileInfo">视频格式：{{ fileInfo.fileSuffix }}</div>
      </template>
      <div flex="cross:center">
        <el-button type="primary" @click="againUpload" class="dialog-submit">重新上传</el-button>
        <el-button @click="remove" class="dialog-close">删除</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import audioPlay from '@/components/BusinessComponents/bc-file-render/audio-play'
import videoPlay from '@/components/BusinessComponents/bc-file-render/video-play'

export default {
  name: 'bc-file-render',
  components: {
    audioPlay,
    videoPlay
  },
  props: {
    fileInfo: {
      type: Object,
      default: () => ({
        fileUrl: '',
        fileType: '',
        fileSuffix: ''
      }),
      required: true
    },
    showHandler: {
      type: Boolean,
      default: true
    },
    mobile: {
      type: Boolean,
      default: false
    },
    isLineFile: {
      type: Boolean,
      default: false
    },
    playbackControl: {
      type: String,
      default: '0'
    }
  },
  computed: {
    fileType() {
      let type
      if (this.fileInfo.fileType.includes('image')) type = 'image'
      if (this.fileInfo.fileType.includes('audio')) type = 'audio'
      if (this.fileInfo.fileType.includes('video')) type = 'video'
      return type
    }
  },
  methods: {
    againUpload() {
      this.$emit('againUpload')
    },
    remove() {
      this.$emit('remove')
    }
  }
}
</script>

<style lang="scss" scoped>
.image-file {
  width: 218px;
  object-fit: scale-down;
}

.video-file {
  width: 408px;
}

.file-render {
  //margin-top: 16px;
  width: 100%;
}

.file-info {
  flex: 1;
  min-width: 0;

  &.videoHandler {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .fileName {
      font-size: 18px;
      color: #333333;
      margin-bottom: 19px;
    }
    .fileInfo {
      font-size: 14px;
      color: #666666;
      margin-bottom: 19px;
    }
  }
}
</style>
